import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '@tytapp/environment';
import { Redirection, AppConfig } from '../../common';

@Component({
  selector: 'tyt-redirection',
  templateUrl: './redirection.component.html',
  styleUrls: ['./redirection.component.scss']
})
export class RedirectionComponent implements OnInit {

  constructor(
    private route : ActivatedRoute,
    private router : Router,
    private redirection : Redirection,
    private appConfig : AppConfig
  ) { }

  ngOnInit() {
    this.route.data.subscribe(data => {
      if (data.id == 'join')
        this.redirection.go(environment.urls.purchase);
      else if (data.id == 'account')
        this.redirection.go(`${environment.urls.accounts}/account`);
      else if (data.id == 'profile')
        this.redirection.go(`${environment.urls.accounts}/profile`);
      else 
        this.redirection.go(`/`);
    });
  }

}
